export const LobbyTypes = Object.freeze({
    ENDORSE: 'endorse',
    OPPOSE: 'oppose',
    NONE: 'none',
});

export const LeadershipOfficeNames = Object.freeze({
    0: 'The President',
    1: 'Speaker of the House',
    2: 'Senate Majority Leader',
    3: 'Senate Minority Leader',
    4: 'House Minority Leader',
});
